<template>
	<div class="queues ui-table">
		<table class="table">
            <thead>
                <tr class="pl5">
                    <th></th>
                    <th>Fila</th>
                    <th>Código</th>
                    <th>Label</th>
                    <th></th>
                </tr>
            </thead>
			<tbody>
				<ui-queues-table-item v-for="(item, index) in leadList"
					:key="index"
					:index="index"
					:data="item"
					:leads="leads" />
			</tbody>

			<tfoot>
				<tr>
					<td class="actions" colspan="5">
						<ui-button :loading="buttonLoading" :disabled="!leads.length" design="success md" @click="submit()">
							<em class="fal fa-cog"></em> Gerar Código
						</ui-button>
						<ui-button design="primary md" :disabled="!leadList.length" @click="addEmptyItem">
							<em class="fal fa-plus"></em> Adicionar Fila
						</ui-button>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import uiQueuesTableItem from '../queues-table-item'

	import { storage } from '@/services/storage'
	import { tokens } from '@/services/axios'
	import { lead } from '@/services/axios'

	import { mapGetters, mapActions } from 'vuex'

	import helpers from '@/mixins/helpers'

	export default {
		components: {
			uiButton,
			uiQueuesTableItem,
		},

		mixins: [helpers],

		data() {
			return {
				leads: [],
				apiConfig: JSON.parse(storage.get('api_config')),
                code: null,
				buttonLoading: false
            }
        },

        props: {
            value: {
                type: String,
                required: false
            },

            title: {
                type: String,
                required: false,
                default: ''
            }
        },

        methods: {
            ...mapActions('chat', {
                addItem: 'addLead',
                setLead: 'setLead',
                clearLeads: 'clearLead'
            }),

            submit() {
				this.buttonLoading = true

				tokens
					.chat()
					.then((response) => {
						if (response.data && response.data.msg) {
							this.$toastr.e(response.data.msg)
						} else {
							let menuQueue = []

							this.leadList.map((e) => {
								if (e.name && e.id) {
									menuQueue.push({
										Label: e.name,
										id: e.id,
									})
								}
							})

							this.code = `
                                    !function(){window;var t=document,e=t.createElement("script"),a="https://cdn.appfacilita.com/static/facilita-chat/",c="_assets/_js/";e.type="text/javascript",e.id="facilita-chat-widget",e.src=a+c+"widget.js";var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(e,i);var s=t.createElement("script");s.type="text/javascript",s.id="facilita-chat-storage",s.async=!0,s.src=a+c+"storage.js";var r=t.getElementsByTagName("script")[1];r.parentNode.insertBefore(s,r)}();
                                    function facilitaChatAction(e){var t="facilita-chat-storage",o=sessionStorage.getItem(t);(o=JSON.parse(o)).open;function a(e){var t={action:e};document.getElementById("chat-iframe-button").contentWindow.postMessage(t,"*"),window.postMessage(t,"*")}switch(e){case"open":a("open");break;case"close":a("close");break;case"toggle":a("toggle")}sessionStorage.setItem(t,JSON.stringify(o))}
                                    facilitaSettings={instancia:"${this.apiConfig.instance}",queue:"",local:!1,source:"${this.leadList[0].name}",gstoken:"${response.data.token_platform}",open:!0,
									gstokenUser:"${response.data.token_user}",
									menuQueueTitle:"${this.queueTitle}", menuQueue: ${JSON.stringify(menuQueue)}};
                                    // se você deseja iniciar o chat fechado na primeira vez que o usuário entra no site altere o parametro open para false
                                    // você pode abrir e fechar a janela do chat chamando a função facilitaChatAction() no evento onClick do elemento
                                    // a função facilitaChatAction() aceita 3 parâmetros. toggle, open, close
                                    // exemplo: <button type="button" id="abrir" onclick="facilitaChatAction('toggle')">Abrir e fechar chat</button>
                            `

							this.$nextTick(() => {
								this.$emit('input', this.code)
							})
						}
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.load = false
						this.buttonLoading = false
					})
			},

			addEmptyItem() {
				this.addItem({
					id: null,
					index: null,
					name: null,
				})
			},
		},

		mounted() {
			this.$root.$on('modal-open-marketing-queues-multiple-chat-code', () => {
				lead.dataTable({
					page: 1,
					perPage: 100,
					search: '',
					filter: [
						{
							name: 'lead_type',
							value: 'chat',
						},
					],
				})
                    .then(response => {
                        this.clearLeads()

						this.leads = response.data.data.map(e => {
                            return {
                                id: e.lead_id,
                                name: e.lead_name
                            }
                        })

                        this.$nextTick(() => {
                            if (this.leads.length) this.addEmptyItem()
                        })
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
            })
        },

        computed: {
            ...mapGetters('chat', {
                leadList: 'getAll'
            }),

            queueTitle(){
                return this.title
            }
        },

		beforeDestroy(){
			this.$root.$off('modal-open-marketing-queues-multiple-chat-code')
		}
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
